const useMatomoEvent = () => {
  const trackEvent = (category, action, label) => {
    if (typeof window !== "undefined" && window._paq) {
      window._paq.push(["trackEvent", category, action, label]);
    }
  };

  return trackEvent;
};

export default useMatomoEvent;
